import http from "@/http-common";

/* eslint-disable */
class OrderService {

    getCustomerPurchaseHistory(page,data): Promise<any> {
      return http.post("/customer/purchase-history?page=" + page, data);
    }

    getOrderDetails(customerId, orderId) {
      return http.get('/customer/' + customerId + '/order/' + orderId + '/details')
    }

    getCustomerQuotations(page,data): Promise<any> {
      return http.post("/customer/quotations?page=" + page, data);
    }

}
  
export default new OrderService();
